import { contentDomain, mockServicePath } from "../../constants/connections";
import { getLocale } from "../handshakeUtils/handshakeUtils";

const appbase = "/client-chat-ui";

export const BASE_PATH = process.env.NODE_ENV !== "development" ? appbase : "";

export const getAEMServiceURL = ({ serviceUrl, locale, serveMock }) => {
  const langDomain = contentDomain;
  const domain = serveMock ? mockServicePath : langDomain;
  const publicPath = serveMock ? "/public/mock/" : "";
  const serveMockBasePath = serveMock ? BASE_PATH : "";
  return `${domain}${serveMockBasePath}${publicPath}${locale}/${serviceUrl}.model.json`;
};

export const aemTemplatePath = () => {
  const locale = getLocale();
  const serveMock = false;
  const serviceUrl = "client-chat-ui";
  const aemPath = getAEMServiceURL({
    serviceUrl,
    serveMock,
    locale,
  });
  console.log("aemPath", aemPath);
  return aemPath;
};
